import { IOSNativeWebView } from './api';
import { iOS } from './api/utils';

export { useAdobePrimetime, AdobePrimetimeProvider } from './shared/context/useAdobePrimetime';

export const NativeWebView = iOS ? IOSNativeWebView : null;
